import h from 'hyperscript';
import { getIconForProfileGroup } from 'cadenza/map/routing/routing-sidebar/profile/routing-profile-service';
import { icon } from 'cadenza/utils/icon/icon';
import {
  ROUTE_ATTRIBUTES_FORMATTERS,
  ROUTE_ATTRIBUTES_ICONS
} from 'cadenza/map/routing/routing-sidebar/route/route-utils';

import i18n from './layer-legend-route-summary.properties';
import './layer-legend-route-summary.css';

const NAME = 'd-layer-legend-route-summary';

export class LayerLegendRouteSummary extends HTMLElement {

  #routeSummary;

  /**
   * Component's constructor
   *
   * @param {object} routeSummary - Route summary
   * @param {string} routeSummary.routingProfileGroup - Routing profile group of the route
   * @param {number} routeSummary.duration - Route duration in seconds
   * @param {number} routeSummary.distance - Distance in meters
   * @param {number} routeSummary.ascent - Ascent in meters
   * @param {number} routeSummary.descent - Descent in meters
   */
  constructor (routeSummary) {
    super();
    this.#routeSummary = routeSummary;
  }

  connectedCallback () {
    this.classList.add(NAME);
    this._renderContent();
  }

  cloneNode () {
    const clone = new LayerLegendRouteSummary(this.#routeSummary);
    if (this.parentElement) {
      clone.connectedCallback();
    }
    return clone;
  }

  _renderContent () {
    const profileIcon = getIconForProfileGroup(this.#routeSummary.routingProfileGroup);
    const titleText = i18n('title');
    this.innerHTML = '';

    this.setAttribute('title', titleText);

    this.append(
      h(`span.${NAME}--icon`, profileIcon),
      ...createValues(this.#routeSummary)
    );
  }

}

customElements.define(NAME, LayerLegendRouteSummary);

const INCLUDED_VALUES = [ 'duration', 'distance', 'ascent', 'descent' ];

export function createValues (values) {
  return Object.entries(values)
    .filter(([ key ]) => INCLUDED_VALUES.includes(key))
    .map(([ key, value ]) => {
      if (value == null) {
        return null;
      }
      const valueIcon = ROUTE_ATTRIBUTES_ICONS[key];
      const formattedValue = ROUTE_ATTRIBUTES_FORMATTERS[key](value);
      return h(`.${NAME}--value`, [
        h(`span.${NAME}--value--icon`, icon(valueIcon)),
        h(`span.${NAME}--value--label`, formattedValue)
      ]);
    });
}
